const hostname = window && window.location && window.location.origin;
const basePath = "/firm_api";
const domain = `${hostname}${basePath}/v1/CustomFields`

//var domain = "http://localhost:63925/api/v1/CustomFields";
export default {
  getCustomField: `${domain}/GetCustomFieldsAssignedToFirm`,
  saveCustomField: `${domain}/CreateOrUpdateCustomFields`
};
